import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Tooltip, { TooltipPlacement } from "molecules/tooltips/tooltip";
import React from "react";
import { ConversationStateStatus } from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import { t } from "utilities/localization-utils";

interface ChatMessageUserActionsProps {
    conversationStatus: ConversationStateStatus;
    handleCopyClick: () => void;
    handleEditClick: () => void;
}

const BASE_CLASS = "c-chat-modal-message";

const ChatMessageUserActions: React.FC<ChatMessageUserActionsProps> = (
    props
) => {
    const { conversationStatus, handleCopyClick, handleEditClick } = props;

    return (
        <div className={`${BASE_CLASS}__prompt-actions`}>
            <Tooltip
                content={t("copy")}
                hideOnClick={true}
                durationInMs={0}
                placement={TooltipPlacement.Bottom}>
                <Button
                    onClick={handleCopyClick}
                    style={ButtonStyles.Tertiary}
                    size={ButtonSizes.XSmall}>
                    <Icon type={Icons.Copy2} cssClassName={"-message-icons"} />
                </Button>
            </Tooltip>
            {conversationStatus ===
                ConversationStateStatus.ConversationReady && (
                <Tooltip
                    content={t("edit")}
                    hideOnClick={true}
                    durationInMs={0}
                    placement={TooltipPlacement.Bottom}>
                    <Button
                        onClick={handleEditClick}
                        style={ButtonStyles.Tertiary}
                        size={ButtonSizes.XSmall}>
                        <Icon
                            type={Icons.Pencil}
                            cssClassName={"-message-icons"}
                        />
                    </Button>
                </Tooltip>
            )}
        </div>
    );
};

export default ChatMessageUserActions;
